module.exports = __webpack_public_path__ + "static/media/021.110bef85.jpg";